import { useQueryWithStore } from 'react-admin';
export const GetIndustryCategory = (obj) => {

  const industryCategory = useQueryWithStore({
    type: 'getOne',
    resource: 'Industry',
    payload: { id: obj.id }
  });

  return industryCategory;
}

export const FetchIndustries = () => {

  const industryCategories = useQueryWithStore({
    type: 'getList',
    resource: 'Industry',
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 10 },
      sort: { field: 'Category', order: 'DSC' },
    }
  });

  return industryCategories;
}


export const GetCertificates = () => {
  const certis = useQueryWithStore({
    type: 'getList',
    resource: 'Certification',
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'certificateName', order: 'ASC' },
    }
  });

  return certis;
}